<template>
	<div>
		<div class="container-fluid conteudo">
			<cabecalho-modelo
				:titulo="titulo"
				:sub-titulo="subTitulo"
				:submenu-modulo="submenuModulo"
				@click-novo="clickNovo"
				exibe-cadastro
                v-if="exibeCabecalho"
			/>

			<div class="text-center" v-show="carregando">
				<flCarregando />
			</div>
			<div v-show="!carregando">
				<Tabela
					:dados-tabela="dadosTabela"
					:colunas-tabela="colunasTabela"
					:colunas-filtro="colunasFiltro"
					:label-item="labelItem"
					:coluna-descricao="colunaDescricao"
					:exibe-editar="exibeEditar"
					:exibe-excluir="exibeExcluir"
					:exibe-busca="exibeBusca"
					@click-editar="clickEditar"
					@click-excluir="clickExcluir"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import Tabela from './tabela.vue'

export default {
	components: {
		Tabela
	},

	props: {
		titulo: {
			type: String,
			required: true
		},

		subTitulo: {
			type: String,
			required: true
		},

		dadosTabela: {
			type: Array,
			required: true
		},

		colunasTabela: {
			type: Array,
			required: true
		},

		labelItem: {
			type: String,
			required: true
		},

		colunaDescricao: {
			type: String,
			required: true
		},

		colunasFiltro: {
			type: Array,
			required: false,
			default: []
		},

		carregando: {
			type: Boolean,
			required: false,
			default: false
		},

		exibeCadastro: {
			type: Boolean,
			required: false,
			default: true
		},

		exibeEditar: {
			type: Boolean,
			required: false,
			default: false
		},

		exibeExcluir: {
			type: Boolean,
			required: false,
			default: false
		},

		submenuModulo: {
			type: String,
			required: false,
			default: 'ad'
		},

		exibeCabecalho: {
			type: Boolean,
			required: false,
			default: true
		},

		exibeBusca: {
			type: Boolean,
			required: false,
			default: true
		}
	},

	data() {
		return {
			busca: '',
			cadastroNovo: true
		}
	},

	methods: {
		clickNovo() {
			this.cadastroNovo = true
			this.$emit('click-novo')
		},

		clickEditar(itemTabela) {
			this.cadastroNovo = false
			this.$emit('click-editar', itemTabela)
		},

		clickExcluir(itemTabela) {
			this.$emit('click-excluir', itemTabela)
		}
	}
}
</script>
